import type {
  ApiReturnMeasuresValidated,
  ApiReturnResource,
} from '@highimpact-frontend/api-types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { api_data_dasboard } from '../api/api-commons';
import resourceService from '../api/services/config/resource/ResourceService';
import { setResources } from './data/slice';
import type { State } from './data/state';

export const loadResources = createAsyncThunk<void, number[]>(
  'data/load-resources',
  async (resourceIds, thunkAPI): Promise<void> => {
    if (resourceIds) {
      const LoadingResource = resourceIds.reduce((acc, id) => {
        acc[id] = {
          _tag: 'loading',
          type: 'resource',
          id,
        };
        return acc;
      }, {} as { [key: number]: State<number, ApiReturnResource> });

      await thunkAPI.dispatch(setResources({ values: LoadingResource }));

      const data = await resourceService.get(resourceIds);

      const resources = resourceIds.reduce((acc, id) => {
        const resource = data.find((rcs) => rcs.id === id);
        acc[id] = {
          _tag: 'data',
          type: 'resource',
          id,
          data: resource!,
        };
        return acc;
      }, {} as { [key: number]: State<number, ApiReturnResource> });

      thunkAPI.dispatch(setResources({ values: resources }));
    }
  }
);

export const fetchDataWithParams = createAsyncThunk<
  { url: string; data: ApiReturnMeasuresValidated },
  string,
  { rejectValue: string }
>('dataWithParams/fetch', async (url, thunkAPI) => {
  try {
    const res = await api_data_dasboard.get(url);
    if (res.status >= 400) throw new Error('Network error');
    const data = (await res.data) as ApiReturnMeasuresValidated;
    return { url, data };
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Unknown error';
    return thunkAPI.rejectWithValue(message);
  }
});
